import React from 'react';

const ManageContact = () => {
  return (
    <div>
      
    </div>
  );
};

export default ManageContact;